import {ParseErrorType} from '../idHelpers.enums';
import {ParseError} from '../idHelpers.types';
import formatWrongPrefixError from './formatWrongPrefixError';
import formatInvalidIdError from './formatInvalidIdError';

export default function formatParseError(error: ParseError): string {
  if (error.errorType === ParseErrorType.WrongPrefix) {
    return formatWrongPrefixError(error);
  }

  return formatInvalidIdError(error);
}
